import { getClientCookie, setClientCookie } from '../utils/cookie';
import uuid from '../utils/uuid';

export const SESSION_ID_COOKIE_NAME = 'songwhip.sessionId';
export const CLIENT_ID_COOKIE_NAME = 'songwhip.clientId';

export const getSessionId = (() => {
  if (!process.browser) {
    return () => {
      throw new Error('not for serverside use');
    };
  }

  const prev = getClientCookie(SESSION_ID_COOKIE_NAME);

  // include the timestamp so songwhip-events can infer when the session started
  const sessionId = prev || `${Date.now()}:${uuid()}`;

  if (!prev) {
    setClientCookie(SESSION_ID_COOKIE_NAME, sessionId, 0);
  }

  return () => ({
    sessionId,

    /**
     * If there isn't a clientId cookie on app start
     * then we regard this as the 'new session' or 'session start'.
     */
    isSessionStart: !prev,
  });
})();

export const getClientId = (() => {
  const CLIENT_ID_COOKIE_NAME = 'songwhip.clientId';

  // not for use on serverside
  if (!process.browser) {
    return () => {
      throw new Error('not for serverside use');
    };
  }

  const prevClientId = getClientCookie(CLIENT_ID_COOKIE_NAME);

  // create and store a new clientId
  const clientId = prevClientId || uuid();

  if (!prevClientId) {
    setClientCookie(CLIENT_ID_COOKIE_NAME, clientId);
  }

  return () => ({
    clientId,

    /**
     * If there isn't a clientId cookie on app start
     * then we regard this as the 'first visit'.
     */
    isFirstVisit: !prevClientId,
  });
})();
